import { Injectable } from '@angular/core';

import {
  DeviceSettingsRepository,
  WebCommonStorageRepository,
} from 'webcommon/legacy-common';

import {
  AprimaNowDeviceSettingsDto,
  AprimaNowProviderSettingsDto,
  MessageSettingsDto,
  ProviderDashboardSettingsDto,
  ScheduleSettingsDto,
} from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class ProviderSettingsDtoMapperService {
  constructor(
    private deviceSettingsRepository: DeviceSettingsRepository,
    private webCommonStorageRepository: WebCommonStorageRepository,
  ) {
  }

  getProviderSettingsDto(): AprimaNowProviderSettingsDto {
    const deviceSettings: AprimaNowDeviceSettingsDto = {
      DashboardSettings: this.mapDashboardTilesToDto(),
      ScheduleSettings: this.mapScheduleSettingsToDto(),
      MessageSettings: this.mapMessageSettingsToDto(),
      GeneralNoteTypes: {
        PhoneMessageGeneralNoteTypeId: this.webCommonStorageRepository.getPhoneMessageGeneralNoteTypeId(),
        TaskMessageGeneralNoteTypeId: this.webCommonStorageRepository.getTaskMessageGeneralNoteTypeId(),
        PortalMessageGeneralNoteTypeId: this.webCommonStorageRepository.getPortalMessageGeneralNoteTypeId(),
        DefaultVitalsSettingId: this.webCommonStorageRepository.getPatientVitalsDefaultSettingId(),
        RxRefillMessageGeneralNoteTypeId: this.webCommonStorageRepository.getRxRefillMessageGeneralNoteTypeId(),
        PharmacyGeneralNoteTypeId: this.webCommonStorageRepository.getPharmacyGeneralNoteTypeId(),
      },
    };

    return {
      PhoneSettings: this.deviceSettingsRepository.isPhone ? deviceSettings : null,
      TabletSettings: this.deviceSettingsRepository.isTablet ? deviceSettings : null,
      DesktopSettings: this.deviceSettingsRepository.isBrowser || this.deviceSettingsRepository.isPrm ? deviceSettings : null,
    };
  }

  private mapScheduleSettingsToDto(): ScheduleSettingsDto {
    const scheduleSettings = this.webCommonStorageRepository.getAppointmentsListSettings();
    const scheduleBadgeSettings = this.webCommonStorageRepository.getAppointmentsBadgeSettings();

    const scheduleCalendarIds = !scheduleSettings ? [] : scheduleSettings.calendarIds;
    const hideDischargedAppointments = !scheduleBadgeSettings ? true : scheduleBadgeSettings.hideDischarged;
    const displayEndTime = !scheduleSettings ? false : scheduleSettings.displayEndTime;
    const findSlotForNewAppt = !scheduleSettings ? false : scheduleSettings.findSlotForNewAppt;

    return {
      ScheduleCalendarIds: scheduleCalendarIds,
      HideDischargedAppointments: hideDischargedAppointments,
      DisplayEndTime: displayEndTime,
      FindSlotForNewAppt: findSlotForNewAppt,
    };
  }

  private mapMessageSettingsToDto(): MessageSettingsDto {
    const messageSettings = this.webCommonStorageRepository.getMessagesListSettings();

    if (!messageSettings) {
      return {
        MessageFilterIds: [],
      };
    }

    return {
      MessageFilterIds: messageSettings.filters.map(f => {
        return f.Id;
      }),
    };
  }

  private mapDashboardTilesToDto(): ProviderDashboardSettingsDto {
    const dashboardTiles = this.webCommonStorageRepository.getDashboardTileSettings();

    if (!dashboardTiles) {
      return {
        Tiles: [],
      };
    }

    for (const tile of dashboardTiles.Tiles) {
      // TODO: use proper typing to remove cast to any
      const t = tile as any;
      if (t.Calendar) {
        t.Calendars = [t.Calendar];
      }
    }

    return dashboardTiles;
  }
}
